import base from '@/http/url_base';

export default {
  ARTICLE: base.API + '/articles',
  GET_REQUIREMENTS: base.API + '/articles/requirements',
  SEARCH_ARTICLE: base.API + '/articles/search',
  //SEARCH_PRODUIT_LOT: base.API + '/articles/search-lot',
};
